import React, { useContext } from 'react';
import { InjectableContexts, useWindowedObservable } from '@procom-labs/common';
import { AlertContext } from '../contexts';
export var useAlert = function() {
    var context = useWindowedObservable(InjectableContexts.Alert);
    return useContext(context !== null && context !== void 0 ? context : AlertContext);
};
